import { useState } from "react";
import { useLocation } from "react-router-dom";
import AddSubWorkspacePopup from "../../Components/Popup/AddSubWorkspacePopup";
import { usePlan } from "../../Context/PlanContext";
import {
  useSubworkspaceStore,
  useUserStore,
  useWorkspaceStore,
} from "../../Context/store";

import MessageToggleNav from "../Sidebar/MessageToggleNav";
import ForumsFeedbar from "./ForumsFeedbar";
import ForumTitle from "./ForumTitle";
import WorkspaceFeedbar from "./WorkspaceFeedbar";
import WorkspaceTitle from "./WorkspaceTitle";

export default function FeedSidebar_V1() {
  const location = useLocation();
  const { pathname } = location;
  const { user: loggedInUser } = useUserStore();
  const { selectedWorkspace } = useWorkspaceStore();
  const { selectedSubWorkspace, subWorkspaceList } = useSubworkspaceStore();

  const { currentPlan } = usePlan();
  const [popup, setPopup] = useState(false);

  return (
    <div className={`hidden bg-secondary h-full rounded-l-lg md:block w-full`}>
      <div className="h-16 px-4 flex justify-between items-center ">
        {pathname !== "/createprofile" && <WorkspaceTitle />}
      </div>
      {pathname !== "/createprofile" && (
        <hr className=" bg-gray-500 border-debatePalette-hr border-1 dark:bg-gray-700" />
      )}
      <div className=" h-[calc(100vh-9.1rem)] overflow-y-auto sidebar-scroller">
        <WorkspaceFeedbar
          loggedInUser={loggedInUser}
          pathname={pathname}
          selectedWorkspace={selectedWorkspace}
          currentPlan={currentPlan}
        />
        <hr className=" bg-gray-500 border-debatePalette-hr border-1 dark:bg-gray-700" />
        {subWorkspaceList?.length > 0 && (
          <>
            <ForumTitle />
            <hr className="bg-gray-500 border-debatePalette-hr border-1 dark:bg-gray-700" />
            <div className="flex h-12 flex-col justify-center px-4">
              <p className="font-semibold text-debatePalette-background">FORUMS</p>
            </div>
            <ForumsFeedbar
              loggedInUser={loggedInUser}
              pathname={pathname}
              selectedSubWorkspace={selectedSubWorkspace}
              currentPlan={currentPlan}
            />
          </>
        )}
        <MessageToggleNav currentPlan={currentPlan} />
      </div>
      <AddSubWorkspacePopup
        handleClose={() => setPopup(false)}
        setPopup={setPopup}
        open={popup}
      />
    </div>
  );
}
